import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ControlItem, ProductTypesEnum } from 'src/app/models/frontend';
import { DiscountTemplatesService } from '../discount-templates.service';
import Swal from 'sweetalert2';
import { ProductType } from 'src/app/models/enums';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-general-discount-template',
  templateUrl: './create-general-discount-template.component.html',
  styleUrls: ['./create-general-discount-template.component.scss']
})
export class CreateGeneralDiscountTemplateComponent {
  productType: ControlItem[] = []
  ID: any
  generalCategory:any=[]
  eventForm:FormGroup
  Role:any
  constructor(public activatedRoute: ActivatedRoute,
    public discountService:DiscountTemplatesService,
    public router:Router,private toastr:ToastrService
    ) {
    this.productType = ProductTypesEnum
    console.log(this.productType)

    this.activatedRoute.params.subscribe(params => { this.ID = params['id'].replace('id', '') });
    console.log(this.ID)
    this.Role=localStorage.getItem("RoleType")
  }
  Submit(domestic,international,prid,health) {
      this.generalCategory.push({productType:ProductType.DomesticTopUp,discountPercentage:domestic,discountTemplateId:this.ID})
      this.generalCategory.push({productType:ProductType.InternationalTopUp,discountPercentage:international,discountTemplateId:this.ID})
      this.generalCategory.push({productType:ProductType.PridExpress,discountPercentage:prid,discountTemplateId:this.ID})
      this.generalCategory.push({productType:ProductType.Health,discountPercentage:health,discountTemplateId:this.ID})

      for(let i=0;i<=this.generalCategory.length;i++){
        this.discountService.CreateGeneralDiscountTemplate(this.generalCategory[i]).subscribe((res:any)=>{
          if(i=3){
            // Swal.fire('Created', '', 'success')
            this.toastr.success('Created','Success');
            this.router.navigateByUrl("discount-templates");
          }
        })
      }
  }

  Cancel(){
    this.router.navigateByUrl("discount-templates");
  }
}
